import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import $ from 'jquery'
import echarts from 'echarts'
import VueCropper from 'vue-cropper'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
import Vue2OrgTree from 'vue2-org-tree'

// 导入util
import axios from './util/axios'
import device from './util/device'
import guid from './util/guid'
import time from './util/time'
import speak from './util/speechSynthesis'
import log_action from './util/action.js'
// import "./util/video.js";
// import cursoreffects from './util/cursor-effects.js'
import './util/protocolcheck.js'
import config from './util/config.js'
import aes from './util/aes.js'
import cors from 'koa2-cors'
import publicMethods from './util/publicMethods.js'
Vue.config.productionTip = false
Vue.prototype.$device = device
Vue.prototype.$http = axios
Vue.prototype.$echarts = echarts
Vue.prototype.$loading = ElementUI.Loading.service
Vue.prototype.$msgbox = ElementUI.MessageBox
Vue.prototype.$alert = ElementUI.MessageBox.alert
Vue.prototype.$confirm = ElementUI.MessageBox.confirm
Vue.prototype.$prompt = ElementUI.MessageBox.prompt
Vue.prototype.$notify = ElementUI.Notification
Vue.prototype.$guid = guid
Vue.prototype.$time = time
Vue.prototype.$config = config
Vue.prototype.$aes = aes
Vue.prototype.$ = $
Vue.prototype.$speak = speak
Vue.prototype.$publicMethods = publicMethods

Vue.use(VueClipboard)
Vue.use(VueCropper)
Vue.use(ElementUI)
Vue.use(Vue2OrgTree)
Vue.use(cors)

//放在Vue.use(ElementUI) 后边，重写已添加message方法
Vue.prototype.$message = function(msg) {
	//弹出提示框
	// 页面顶部-中间提示框
	// ElementUI.Message(msg)
	// 四角提示框
	ElementUI.Notification({
		title: '提示',
		message: msg.message,
		type: msg.type,
		duration: 3000,
		position: 'bottom-right'
	})

	//增加语音播放功能---开始
	speak.speak(msg.message)
	//增加语音播放功能---结束

	//记录提示信息
	let log_pageAction = {
		typeName: msg.type, //提示类型
		message: msg.message, //提示内容
		routerPath: router.history.current.path, //路由地址
		exploreName: device.exploreName, //终端
		os: JSON.stringify(device.os), //系统
		userID: store.getters["getUserInfo"]
	}
	log_action.saveActionLog(log_pageAction, this.$http)
}




//全屏
Vue.prototype.$fullScreen = function() {
	let element = document.documentElement;
	if (element.requestFullscreen) {
		element.requestFullscreen();
	} else if (element.msRequestFullscreen) {
		element.msRequestFullscreen();
	} else if (element.mozRequestFullScreen) {
		element.mozRequestFullScreen();
	} else if (element.webkitRequestFullscreen) {
		element.webkitRequestFullscreen();
	}

	//禁用esc
}

//退出全屏
Vue.prototype.$exitFullscreen = function() {
	if (document.exitFullscreen) {
		document.exitFullscreen();
	} else if (document.msExitFullscreen) {
		document.msExitFullscreen();
	} else if (document.mozCancelFullScreen) {
		document.mozCancelFullScreen();
	} else if (document.webkitExitFullscreen) {
		document.webkitExitFullscreen();
	}

	//解除禁用esc

}

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = config.sysName + '-' + to.meta.title
	}
	next()
})

new Vue({
	router,
	render: h => h(App)
}).$mount('#app')
